<template>
  <div v-if="displayed" class="gw-overlay">
    <CloseButton @click.native="close" />
    <div class="gw-overlay__summary">
      {{ $tc('message.GW_N_ONGOING', gwNb, { nb: gwNb }) }}
    </div>
    <div class="gw-overlay__wrapper">
      <div v-for="gw in ongoingGWs" :key="gw.id">
        <RouterLink class="generic-border v-centerer gw-overlay__item" :to="getGwOngoingLink(gw.id)">
          <div class="gw-overlay__item__name">
            {{ gw.name }}
          </div>
          <div class="gw-overlay__item__date">
            {{ $moment(gw.date).format($t('minDateFormat')) }}
          </div>
        </RouterLink>
      </div>
    </div>
    <div class="gw-overlay__footer">
      <!-- Ignore until next GW feature -->
      <!--button class="add-button blue gw-overlay__ignore-btn" @click="ignore()">
        {{ $t('message.IGNORE') }}
      </button-->
    </div>
  </div>
</template>

<script>
/**
 * GW overlay. Meant to be displayed when a GW has been started and the user
 * left it. Allows the user to get back to the GW or end it.
 * @vue-prop {Object} currentComponent - the current displayed page
 */
// Import component
import CloseButton from '@/components/close-button.vue';
// Import store utils
import { mapState } from 'vuex';
import { FETCH_ONGOING_GW } from '@/store/modules/gemba-walks/action-types';
import { GET_ONGOING_GW } from '@/store/modules/gemba-walks/mutation-types';
import { SET_GW_OVERLAY_VISIBILITY, SET_GW_OVERLAY_LAST_DATE } from '@/store/mutation-types';
// Import utils
import { calert } from '@/utils/main';


export default {

  name: 'GwOverlay',

  components: { CloseButton },

  props: {
    currentComponent: Object,
  },

  data() {
    return {
      gwComponents: [
        'GwOngoing',
        'GwCompleted',
      ],
      gembaWalks: [],
    };
  },

  computed: {
    displayed() {
      return this.currentComponent
        && !this.App.user.gwHideOverlay
        && this.ongoingGWs.length > 0
        && !this.allGWsIgnored
        && !this.gwComponents.includes(this.currentComponent.$options.name)
        && !this.hidden;
    },
    gwNb() {
      return this.ongoingGWs.length;
    },
    ongoingGWs() {
      return this.$store.state.gembaWalks[GET_ONGOING_GW.stateKey] || [];
    },
    allGWsIgnored() {
      return !this.ongoingGWs.some(gw => this.$moment(gw.date) > this.lastIgnoredMoment);
    },
    hidden: {
      get() {
        return !this.$store.state.gwOverlayVisibility;
      },
      set(val) {
        this.$store.commit(SET_GW_OVERLAY_VISIBILITY, !val);
      },
    },
    ...mapState({
      lastIgnoredMoment: state => state.gwOverlayLastDate,
    }),
  },

  mounted() {
    // Fetch ongoing GW
    this.$store.dispatch(`gembaWalks/${FETCH_ONGOING_GW}`);
  },

  methods: {
    close() {
      this.hidden = true;
      // Re-show after 1 hour. Shizen needs the users to end their GWs
      setTimeout(() => {
        this.hidden = false;
      }, 3600000);
    },
    /**
     * Ignore all ongoing GW until now
     */
    ignore() {
      calert(this.$t('message.NOTICE_GW_OVERLAY_IGNORE'), [
        {
          title: this.$t('message.OK'),
          action: () => {
            this.$store.commit(SET_GW_OVERLAY_LAST_DATE, this.$moment());
          },
        },
        {
          title: this.$t('message.CANCEL'),
        },
      ]);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";
.gw-overlay {
  max-width: 50%;
  position: fixed;
  top: 80px;
  right: 10px;
  box-sizing: border-box;
  background: $color-body-background;
  border-radius: $main-border-radius;
  box-shadow: $dark-box-shadow;
  padding: $page-content-padding 0;

  .close-button {
    left: 5px;
    top: 5px;
  }

  &__summary {
    margin: 0px 20px 10px 45px;
  }

  &__wrapper {
    max-height: 220px;
    overflow: auto;
    padding: 0 $page-content-padding;
  }


  &__item {
    width: 100%;
    padding: .5rem 1rem;
    margin-top: .6rem;
    box-sizing: border-box;
    cursor: pointer;

    &:hover {
      background-color: $color-hoverbtn-light-blue;
    }

    &__name {
      overflow: hidden;
      height: 1.5em;
      text-overflow: ellipsis;
      width: calc(100% - 45px);
      white-space: nowrap;
      margin-right: 5px;
    }

    &__date {
      width: 45px;
      font-style: italic;
    }
  }

  &__footer {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding: 4px 6px;
    padding-bottom: 0;
  }

  &__ignore-btn {
    float: right;
    font-size: 12px;
    padding: 5px 12px;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
